/**
 * src/pages/CifrasLanding.jsx
 * Página propia para las cifras de la landing (Manuel, 27-08, hilo de
 * distribución): vivían al fondo de Estado, donde encontrarlas exigía
 * bajar todo el parte. Es un dato importante — decide si lo que afirma
 * cmmonitor.cl sigue siendo cierto — y merece su puerta en el menú, en
 * Negocio: la pregunta que responde es del negocio, no de la máquina.
 *
 * La tarjeta es la misma de siempre (components/dashboard/CifrasLanding):
 * aquí solo gana sitio.
 */
import { Header } from '../components/layout/Header'
import { CifrasLanding as TarjetaCifras } from '../components/dashboard/CifrasLanding'

export default function CifrasLandingPage() {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Header
        title="Cifras landing"
        subtitle="Lo que afirma cmmonitor.cl frente a lo que hoy se puede medir"
      />
      <div style={{ flex: 1, overflow: 'auto', padding: '24px 28px' }}>
        <div style={{ maxWidth: '900px' }}>
          <TarjetaCifras />
        </div>
      </div>
    </div>
  )
}
